import JobSearchForm from '../forms/job-search-form';

const Masthead = (props) => {
  return (
    <>
      <h1 className="h2 mb-5 text-white">
        College Recruiter believes that every student and recent grad deserves a great career.
      </h1>

      <JobSearchForm />
      <hr />
    </>
  );
};

module.exports = Masthead;
